import Invoices from "@/pages/Invoices";

export default function DevisAcceptes() {
    return (
        <Invoices
            fixedType="devis_accepte"
            overline="Devis acceptés"
            title="Tous vos devis acceptés"
            itemLabel={{ singular: "devis accepté", plural: "devis acceptés" }}
        />
    );
}
